<div class="modal-header bg-soft-info p-3">
    <h5 class="card-title" style="margin-bottom: 0;" i18n="@@">Notification</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()">
    </button>
</div>

<div class="card-body p-4 ">
    <div class="tab-model">
        <div class="invisible-scrollbar" style="min-height: 502px;">
            <div class="row d-flex">
                <div class="mb-3">
                    <label for="jobtitle-field" class="form-label">Subject:</label>
                    <input [disabled]="disableModel" required #title="ngModel"
                        [ngClass]="{ 'is-invalid': (title.invalid && ((title.dirty || title.touched) || submitted == true))}"
                        class="form-control" type="text" placeholder="Enter Note Title" i18n-placeholder="@@"
                        [(ngModel)]="notification.subject" />
                </div>

                <div class="mb-3">
                    <label for="jobtitle-field" class="form-label">Created:</label>
                    <input [disabled]="disableModel" required
                        [ngClass]="{ 'is-invalid': (title.invalid && ((title.dirty || title.touched) || submitted == true))}"
                        class="form-control" type="text" placeholder="Enter Note Title" i18n-placeholder="@@"
                        value=" {{notification.createdDate | amTimeAgo:true}} ago" />
                </div>
            </div>

            <label for="jobtitle-field" class="form-label">Description:</label>
            <app-rich-text-displayer  class="form-control overflow-auto form-disabled " style="height: 370px; max-height: 50vh; overflow-y: scroll;" [textToDisplay]="notification.description"></app-rich-text-displayer>
        </div>
    </div>
</div>